const initialState = {
    data: [],
  };
  
const rozliczenieWodyWmSaved = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_ROZLICZENIE_WODY_WM':
      return { ...state, data: action.payload };
    default:
      return state;
  }
};

export default rozliczenieWodyWmSaved;